import { HotmartRum } from '@hotmart-org-ca/hot-observability-js/rum/react';
import settings from 'common/config/settings';
import { EVENTS } from 'common/constants';
import { dispatchCustomEvent } from 'common/utils/dispatchCustomEvent';
import { isOriginHelpCenter } from 'common/user';
import { AccountsInfo } from 'models';

export const isEmpty = (str: string): boolean => {
  return !str || str.length === 0;
};

export const formatLocaleBlipStyle = (locale: string): string => {
  const languages = {
    pt_BR: 'ptBR',
    fallback: 'ptBR',
    en: 'enUS',
    es: 'esES',
  };
  return languages[locale] || languages.fallback;
};

export const setupAppKey = (): string => {
  return isOriginHelpCenter() ? settings.keys.BLIP_HELPCENTER : settings.keys.BLIP_BW;
};

export const getFormattedAccountData = ({
  name: fullName,
  email,
  locale,
  id,
  entityType,
}: AccountsInfo): Record<string, unknown> => {
  return {
    fullName,
    email,
    culture: formatLocaleBlipStyle(locale),
    extras: {
      //  Account info
      id,
      entityType,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  };
};

type BlipChat = {
  build: () => void;
  destroy: () => void;
};

export const renderWidget = (appKey: string, blipChat: BlipChat): void => {
  try {
    if (appKey) {
      blipChat.build();
      dispatchCustomEvent(EVENTS.ON_BUILD_BLIP_WIDGET, { build: true });
    }
  } catch (e) {
    if (e instanceof Error) {
      HotmartRum.captureException(e);
    }
  }
};

export const dispatchEnterEvent = (): void => {
  dispatchCustomEvent(EVENTS.BLIP_ENTER, { opened: true });
  dispatchCustomEvent(EVENTS.ON_CHAT_OPEN, { open: true });
  dispatchCustomEvent(EVENTS.ON_CHAT_TOGGLE, { open: true });
};

export const dispatchLeaveEvent = (): void => {
  dispatchCustomEvent(EVENTS.ON_CHAT_CLOSE, { open: false });
  dispatchCustomEvent(EVENTS.ON_CHAT_TOGGLE, { open: false });
};

export const destroyWidget = (blipChat: BlipChat): void => {
  try {
    if (!blipChat || typeof blipChat.destroy !== 'function') {
      return;
    }
    blipChat?.destroy();
  } catch (e) {
    if (e instanceof Error) {
      HotmartRum.captureException(e);
    }
  }
};

export const setExtras = (blipChat: any, extras: unknown): void => {
  blipChat.withAccount({
    extras,
  });
};
